import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'app-info-popup',
  imports:[CommonModule],
  standalone: true,
  template: `
    <div class="wrapper"
         (mouseenter)="abrirPopup()"
         (mouseleave)="fecharPopup()">

      <svg width="20" height="20" viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="10" stroke="#FFFFFF" fill="#24ab4a"/>
        <text x="12" y="16" text-anchor="middle" font-size="12" fill="#FFFFFF">i</text>
      </svg>

      <div #popupRef class="popup" [hidden]="!visivel">
        {{ texto }}
      </div>
    </div>
  `,
  styles: [`
    .wrapper { display: inline-block; position: relative;}

    .popup {
      position: fixed;
      padding: 8px 12px;
      background: #333;
      color: #fff;
      border-radius: 5px;
      width: 20rem;
      z-index: 9999;
      white-space: pre-line;
      
    }

    svg, svg text {
      cursor: default !important;
    }

  `]
})
export class InfoPopupComponent {

  @Input() texto = '';
  @ViewChild('popupRef') popupRef!: ElementRef<HTMLElement>;

  visivel = false;

  private mouseX = 0;
  private mouseY = 0;

  @HostListener('mousemove', ['$event'])
  capturarMouse(ev: MouseEvent) {
    this.mouseX = ev.clientX;
    this.mouseY = ev.clientY;
  }

  abrirPopup() {
    this.visivel = true;
     setTimeout(() => {
    requestAnimationFrame(() => {
      this.posicionarPopup();
    });
  });
  }

  fecharPopup() {
    this.visivel = false;
  }

  private posicionarPopup() {
    const popup = this.popupRef.nativeElement;

    const p = popup.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    const espacoAbaixo = viewportHeight - this.mouseY;
    const espacoAcima = this.mouseY;

    let top: number;
    if (espacoAbaixo < p.height  && espacoAcima > p.height) {
      top = this.mouseY - p.height - 8;
    } else {
      top = this.mouseY + 8;
    }

    popup.style.top = `${top}px`;
    popup.style.left = `${this.mouseX + 8}px`;
  }
}
